<div class="gl-table__container">
  <gl-table
    [id]="listId"
    [dataSource]="dataSource"
    data-testid="subscriptionTable"
    [placeholder]="'actions.noResultTable' | translate"
    paginator
    (onDatasourceUpdate)="onDatasourceUpdate($event.detail.dataSource)"
  >
  </gl-table>
</div>
